var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-list-item',_vm._g(_vm._b({attrs:{"ripple":""}},'v-list-item',_vm.item.props,false),_vm.item.on),[(!!_vm.item.icon)?_c('v-list-item-avatar',[_c('v-icon',[_vm._v(_vm._s(_vm.item.icon))])],1):_vm._e(),_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(_vm.item.label))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }